import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getJourneyById } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { useI18n } from '../../../context/occ/hooks/use-i18n';
import { MemberJourneyListContextInstance } from '../types/context';
import { getHeadingForJourneyGroup } from '../utils/get-heading-for-journey-group';
import { MemberJourneyListJourney } from './journey';
const b = bemClassBuilder('v-member-journey-list-group');
export const MemberJourneyListGroup = observer(props => {
    const i18n = useI18n();
    const { journeyGroup } = props;
    const { displayText } = useContext(MemberJourneyListContextInstance);
    const groupHeading = getHeadingForJourneyGroup(journeyGroup, displayText, i18n);
    const journeys = journeyGroup.journeyIds.reduce((acc, nextJourneyId) => {
        const journey = getJourneyById(nextJourneyId);
        if (!!journey)
            acc.push(journey);
        return acc;
    }, []);
    return (_jsxs("div", Object.assign({ className: b.block() }, { children: [_jsx("div", Object.assign({ className: b.element('heading') }, { children: groupHeading })), _jsx("ul", Object.assign({ className: b.element('list') }, { children: journeys.map(journey => (_jsx("li", Object.assign({ className: b.element('list-item') }, { children: _jsx(MemberJourneyListJourney, { journey: journey, journeyGroupType: journeyGroup.type }) }), journey.id))) }))] })));
});
MemberJourneyListGroup.displayName = 'MemberJourneyListGroup';
